const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path fill-rule="evenodd" d="M14.83 18.78a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 1 1 1.06 1.06l-5.47 5.47 5.47 5.47a.75.75 0 0 1 0 1.06" clip-rule="evenodd"/></svg>';
export {
  e as w
};
